module.exports = __webpack_public_path__ + "img/invoca_black.75516ba1.svg";